module.exports = __webpack_public_path__ + "img/usd.12265996.svg";